import { render } from "./FourDimensionRadar.vue?vue&type=template&id=04d1d764&scoped=true"
import script from "./FourDimensionRadar.vue?vue&type=script&lang=js"
export * from "./FourDimensionRadar.vue?vue&type=script&lang=js"

import "./FourDimensionRadar.vue?vue&type=style&index=0&id=04d1d764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d1d764"]])

export default __exports__